import { ActivatedRoute, Router } from "@angular/router";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AuthService } from 'src/app/common/auth/auth.service';
import { environment } from "src/environments/environment";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private router: Router,
  ) { }

  // *
  ptIcon;
  partnerIcon;
  @Output() onCollapseEvent = new EventEmitter();
  isCollapsed = true;
  @Input() currentUser;

  ngOnInit(): void {
      this.ptIcon = 'assets/images/purpletree-logo.svg';
      this.partnerIcon = 'assets/images/azienda-logo.svg';
  }

  onCollapse() {
    this.isCollapsed = !this.isCollapsed;
    this.onCollapseEvent.emit(this.isCollapsed);
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  profile(){
    this.router.navigate(['/profile']);
  }
}
